import React from "react";
import Switch from "./Switch";

export default function TemplateItem({ name, desc, checked, onToggle}) {
	return (
		<li className="flex items-center justify-between px-4 py-3 bg-gray-50 rounded-lg border border-gray-200 shadow-sm">
			<div>
				<div className="text-gray-900 font-medium">{name}</div>
				{desc && <div className="text-xs text-gray-500">{desc}</div>}
			</div>
			<Switch checked={checked} onChange={onToggle}/>
		</li>
	);
}
